<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="title + ' List'"
          :fields="fields"
          :items="data"
          :editButton="true"
          :redirectDetail="false"
          :enableAddButton="true"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
          @previewForm="previewForm"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title" v-if="isEdit == true">Edit Form {{ title }}</h6>
        <h6 class="modal-title" v-if="isEdit == false">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>
      <CForm v-else>
        <CRow>
          <CCol lg="6">
            <CTextarea
              label="Messages"
              invalid-feedback="Messages should be filled"
              required
              v-model="$v.cancelOrderDetailForm.messages.$model"
              :is-valid="!$v.cancelOrderDetailForm.messages.$invalid"
              :rows="4"
            ></CTextarea>
          </CCol>

          <CCol lg="6">
            <CRow>
              <CCol lg="6">
                <template v-if="imgPreviewUrl === null && imgPreview === null">
                  <CInputFile
                    ref="fileupload"
                    label="Attachment"
                    accept="image/*"
                    invalid-feedback="Attachment should be filled"
                    required
                    @change="onFileChange"
                  />
                  <CButton @click="removeImage" color="danger">
                    <i class="fa fa-remove"></i>
                    Remove
                  </CButton>
                </template>
                <template v-else-if="imgPreviewUrl !== null && imgPreview === null">
                  <CButton @click="removeAttachment" color="danger">
                    <i class="fa fa-remove"></i>
                    Remove Attachment
                  </CButton>
                </template>
              </CCol>
              <CCol lg="6">
                <CImg
                  v-if="imgPreviewUrl === null && imgPreview !== null"
                  :src="imgPreview"
                  :width="200"
                  :thumbnail="true"
                />
                <CImg
                  v-else-if="imgPreviewUrl !== null && imgPreview === null"
                  :src="
                    'https://storage.googleapis.com/isikulkas/' +
                    imgPreviewUrl +
                    '?r=' +
                    unixTime
                  "
                  :width="200"
                  :thumbnail="true"
                />
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.cancelOrderDetailForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>

    <CModal
      title="Image Preview"
      color="success"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="preview"
    >
      <CImg
        :src="
          'https://storage.googleapis.com/isikulkas/' +
          cancelOrderDetailForm.attachment +
          '?r=' +
          unixTime
        "
        :thumbnail="true"
      />
    </CModal>
  </div>
</template>

<script>
import Loading from "../../../templates/Loading";
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "Respond_List",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Respond List",
      activeTab: 0,
      fields: [
        { key: "messages", label: "Messages", sorter: true },
        { key: "response_name", label: "Response By", sorter: true },
        { key: "response_time", label: "Response Time", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      cancelOrderDetailForm: tableInterfaces.cancellation_order_detail,
      userForm: tableInterfaces.users,
      addButton: false,
      preview: false,
      items: [],
      isEdit: false,
      isLoading: false,
      content: "",
      editorOption: {}, // data quill
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
      imgPreviewUrl: null,
      imgPreview: null,
    };
  },
  props: {
    cancelOrderData: {
      type: [Array, Object],
      default: () => [],
    },
    cancelOrder: {
      type: [Array, Object],
      default: () => [],
    },
  },
  validations: {
    cancelOrderDetailForm: {
      messages: { required },
      response_by: {},
      response_time: {},
      cancellation_id: {},
      attachment: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  computed: {
    data: function () {
      if (this.cancelOrderData.length > 0) {
        return this.items.length > 0 ? this.items : this.cancelOrderData;
      } else {
        return [];
      }
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0;
    },
    refreshComplaintDetail: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/cancel_order/listing-detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    submitForm: function (event) {
      event.preventDefault();
      this.cancelOrderDetailForm.cancellation_id = this.cancelOrder.id;
      this.cancelOrderDetailForm.order_number = this.cancelOrder.order_number;
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/cancel_order/add-response", this.cancelOrderDetailForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.imgPreview = null;
              this.imgPreviewUrl = null;
              this.refreshComplaintDetail(this.cancelOrder.id);
            });
        }
      } else {
        if (confirm("Do you want to update this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/cancel_order/update-response", this.cancelOrderDetailForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.imgPreview = null;
              this.imgPreviewUrl = null;
              this.refreshComplaintDetail(this.cancelOrder.id);
            });
        }
      }
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.imgPreview = null;
      this.imgPreviewUrl = null;
      this.resetForm();
      this.cancelOrderDetailForm.raw_attachment = null;
    },
    previewForm: function () {
      this.preview = true;
      this.isEdit = false;
      this.addButton = false;
    },
    editForm: function (item) {
      this.isEdit = true;
      this.cancelOrderDetailForm = item;
      this.cancelOrderDetailForm.raw_attachment = null;
      if (item.attachment !== null) {
        this.imgPreviewUrl = item.attachment;
        this.imgPreview = null;
      } else {
        this.imgPreview = null;
        this.imgPreviewUrl = null;
      }
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.cancellation_order_detail) {
        tableInterfaces.cancellation_order_detail[i] = null;
      }
      this.cancelOrderDetailForm = tableInterfaces.cancellation_order_detail;
    },
    cancelForm: function () {
      this.addButton = false;
      this.preview = false;
      this.resetForm();
    },
    onFileChange(e) {
      this.createImage(e[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.cancelOrderDetailForm.raw_attachment = e.target.result;
        this.imgPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.cancelOrderDetailForm.attachment = null;
      this.imgPreview = null;
    },
    removeAttachment: function (e) {
      if (confirm("Do you want to remove this attachment ?")) {
        this.cancelOrderDetailForm.attachment = null;
        this.imgPreview = null;
        this.isLoading = true;
        var remove = {
          images: this.cancelOrderDetailForm.attachment,
          id: this.cancelOrderDetailForm.id,
        };
        this.axios
          .put("console/cancel_order/remove-attachment", remove)
          .then((response) => {
            this.$refs.uploaimage.reset();
            this.$refs.fileupload.value = null;
            this.uploadImageForm.images = null;
            this.products.images = null;
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Issue");
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshComplaintDetail(this.cancelOrder.id);
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
